import React from 'react';
import { Icon, Typography } from '@hevoio/hevo-ui-toolkit';
import HdShortcut from '../../../../../a11y/shortcuts/components/shortcut/HdShortcut';
import styles from './GlobalSearchButton.module.scss';

export function GlobalSearchButton({ onClick, dataId }: { onClick: VoidFunction; dataId: string; }) {
  return (
    <div style={{ maxWidth: '300px' }} className='w-100'>
      <button
        type='button'
        data-id={`${dataId}-global-search`}
        className={styles.globalSearchButton}
        onClick={onClick}
      >
        <Icon name='search' size={2} className='text-icon-sub-600'/>

        <Typography level='paragraph-small' color='soft-400'>Search Anything</Typography>

        <div className='center-flex-row ml-auto'>
          <HdShortcut command='global.searchDialog' />
        </div>
      </button>
    </div>
  );
}
